import { Button } from 'aimo-ui';
import useDownloadSessionPdf from 'hooks/useDownloadSessionPdf';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { testIdentifiers } from 'utils/testIdentifiers';

const ExportPdfButton = ({
  sessionId = '',
  isPaymentFailed,
  chargingSessionId = '',
}: {
  sessionId?: string;
  isPaymentFailed: boolean;
  chargingSessionId?: string;
}) => {
  const { t } = useTranslation();
  const { readChargingSessionPdf, readParkingReceiptPdf, loading } =
    useDownloadSessionPdf();

  const onExportReceiptPDF = () => {
    if (sessionId) {
      readParkingReceiptPdf({
        variables: {
          sessionId,
        },
      });
    }
    if (chargingSessionId) {
      readChargingSessionPdf({
        variables: {
          sessionId: chargingSessionId,
        },
      });
    }
  };

  return (
    <Button
      text={t('button.exportPDF')}
      size="l"
      disabled={isPaymentFailed}
      loading={loading}
      {...testIdentifiers('export-receipt-pdf')}
      onPress={onExportReceiptPDF}
    />
  );
};

export default ExportPdfButton;
